import { render, staticRenderFns } from "./FirstForm.vue?vue&type=template&id=40572d88&scoped=true&"
import script from "./FirstForm.vue?vue&type=script&lang=js&"
export * from "./FirstForm.vue?vue&type=script&lang=js&"
import style0 from "./FirstForm.vue?vue&type=style&index=0&id=40572d88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40572d88",
  null
  
)

export default component.exports